import { LicenseManager as AgChartsLicenseManager } from 'ag-charts-enterprise';
import { LicenseManager as AgGridLicenseManager } from 'ag-grid-enterprise';

let agChartsLicenseKey: string | undefined;
let agGridLicenseKey: string | undefined;

export const initializeSeeqAgChartsEnterpriseLicense = (licenseKey?: string): void => {
  const nextKey = licenseKey || undefined;
  if (agChartsLicenseKey === nextKey) {
    return;
  }

  AgChartsLicenseManager.setLicenseKey(nextKey ?? '');
  agChartsLicenseKey = nextKey;
};

export const initializeSeeqAgGridEnterpriseLicense = (licenseKey?: string): void => {
  const nextKey = licenseKey || undefined;
  if (agGridLicenseKey === nextKey) {
    return;
  }

  AgGridLicenseManager.setLicenseKey(nextKey ?? '');
  agGridLicenseKey = nextKey;
};
